import {
  CART_PUSH_SUBMISSION, CART_PUSH_PRODUCT, CART_REMOVE_ITEM_BY_INDEX,
  CART_REMOVE_ITEM_BY_UUID, CART_SET_CHECKOUT_STATUS, CART_SAVE, CART_CLEAR,
  SET_LAST_PROJECT, SET_LAST_INVOICE
} from '@/store/mutation-types';
import {CART_CHECKOUT, CART_ADD_SUBMISSION, CART_REMOVE_ITEM, CART_CLEAR_ITEMS, CART_ADD_PRODUCT} from '@/store/action-types';
import Vue from "vue";
import UserModel from "../../models/cashier/UserModel";
import moment from "moment";
import Submission from "../../models/legacy/Submission";
import InvoiceModel from "../../models/cashier/InvoiceModel";
import ProjectModel from "../../models/lab/ProjectModel";

let cartItems = window.localStorage.getItem('cartItems');
let cartCount = window.localStorage.getItem('cartCount');
let lastProject = window.localStorage.getItem('lastProject');
let lastInvoice = window.localStorage.getItem('lastInvoice');

const state = {
  items: cartItems ? JSON.parse(cartItems) : [],
  count: cartCount ? parseInt(cartCount) : 0,
  lastProject: lastProject ? lastProject : null,
  lastInvoice: lastInvoice ? lastInvoice : null,
};

const getters = {
  getCartItems: state => state.items,
  getCartCount: state => state.count,
  getCartStatus: state => state.checkoutStatus,
  getLastProjectID: state => state.lastProject,
  getLastInvoiceID: state => state.lastInvoice,
};

const mutations = {
  CART_PUSH_SUBMISSION: function(state, submission){
    state.items.push({
      uuid: Vue.prototype.$uuid.v4(),
      submission
    })
    state.count++;
  },
  CART_PUSH_PRODUCT: function(state, product){
    state.items.push({
      uuid: Vue.prototype.$uuid.v4(),
      product
    })
    state.count++;
  },
  CART_REMOVE_ITEM_BY_INDEX: function(state, index){
    if(index !== null) {
      let found = false;
      state.items.forEach((item, itemIndex) => {
        if(itemIndex === index) {
          found = true;
        }
      });
      if(found) {
        state.items.splice(index, 1);
        state.count--;
      }
    }
  },
  CART_REMOVE_ITEM_BY_UUID: function(state, uuid){
    let index = null;
    state.items.forEach((item, itemIndex) => {
      if(uuid == item.uuid) {
        index = itemIndex;
      }
    });
    if(index !== null) {
      state.items.splice(index, 1);
      state.count--;
    }
  },
  CART_SET_CHECKOUT_STATUS: function(state, status){
    state.checkoutStatus = status;
  },
  CART_SAVE(state) {
    window.localStorage.setItem('cartItems', JSON.stringify(state.items));
    window.localStorage.setItem('cartCount', state.count);
  },
  CART_CLEAR(state) {
    state.items = [];
    state.count = 0;
  },
  SET_LAST_PROJECT: function(state, project_id){
    state.lastProject = project_id;
    window.localStorage.setItem('lastProject', project_id);
  },
  SET_LAST_INVOICE: function(state, invoice_id){
    state.lastInvoice = invoice_id;
    window.localStorage.setItem('lastInvoice', invoice_id);
  },
};

const actions = {

  CART_CHECKOUT: ({commit, state}, {customer, token}) => {
    // console.log('CART_CHECKOUT: start');
    commit(CART_SET_CHECKOUT_STATUS, null);
    let is_credit = !token;
    // console.log('CART_CHECKOUT: ' + (is_credit ? 'invoice' : 'card'));
    return new Promise((resolve, reject) => {
      commit(CART_SET_CHECKOUT_STATUS, 'request');
      let user = new UserModel({
        id: (customer.customer_contacts[0] ? customer.customer_contacts[0].user_id : null),
        name: customer.customer_contacts[0].name,
        email: customer.customer_contacts[0].email,
        source: token,
        credit: is_credit,
      });
      // console.log('CART_CHECKOUT: user hydrated');
      // console.log(user);
      user.forceSave().then(() => {
        // console.log('CART_CHECKOUT: user saved');
        let invoice_payload = {
          user_id: user.id,
          customer_id: customer.id,
          auto_advance: true,
          collection_method: 'charge_automatically',
          credit: is_credit,
          invoice_items: []
        };
        let item_submissions = [];
        state.items.forEach((item) => {
          if(item && item.submission) {
            let submission = new Submission(item.submission);
            invoice_payload.invoice_items.push({
              user_id: user.id,
              currency: 'cad',
              amount: (submission.getTotal(true) * 100),
              description: submission.getTitle()
            });

            let submission_payload = JSON.parse(JSON.stringify(submission))
            delete submission_payload['sample_type']
            delete submission_payload['turnaround']
            delete submission_payload['test_package']

            item_submissions.push(submission_payload)
          } else if(item && item.product) {
            invoice_payload.invoice_items.push({
              user_id: user.id,
              currency: 'cad',
              amount: +(item.product.stock_keeping_units[0].price),
              description: item.product.name,
              metadata: {'product': item.product.stripe_id}
            });
          }
        });
        // console.log('CART_CHECKOUT: invoice payload');
        // console.log(invoice_payload);
        let invoice = new InvoiceModel(invoice_payload);
        // console.log('CART_CHECKOUT: invoice hydrated');
        // console.log(invoice);
        // #TODO: customer_contact_id & customer_location_id (below) need to actually be set -- not just assumed to be index 0
        invoice.save().then(() => {
          // console.log('CART_CHECKOUT: invoice saved');
          let project = new ProjectModel({
            laboratory_id: process.env.VUE_APP_DEFAULT_LABORATORY_ID,
            customer_id: customer.id,
            customer_contact_id: customer.customer_contacts[0] ? customer.customer_contacts[0].id:null,
            customer_location_id: customer.customer_locations[0] ? customer.customer_locations[0].id : null,
            invoice_id: invoice.id,
            submissions: item_submissions,
          });
          // console.log('CART_CHECKOUT: project hydrated');
          // console.log(project);
          let r = project.checkout();
          r.then(() => {
            // console.log('CART_CHECKOUT: project checked out');
            commit(SET_LAST_PROJECT, project.id);
            commit(SET_LAST_INVOICE, invoice.id);
            resolve(project.id)
          }, () => {
            reject('Project create failed');
          });
        }, () => {
          reject('Invoice create failed');
        });
      }, () => {
        reject('Cashier user save failed');
      });
    });
  },

  CART_ADD_SUBMISSION: ({commit}, {submission}) => {
    commit(CART_SET_CHECKOUT_STATUS, null);
    commit(CART_PUSH_SUBMISSION, submission);
    commit(CART_SAVE);
  },

  CART_ADD_PRODUCT: ({commit}, {product}) => {
    commit(CART_SET_CHECKOUT_STATUS, null);
    commit(CART_PUSH_PRODUCT, product);
    commit(CART_SAVE);
  },

  CART_REMOVE_ITEM: ({commit}, {identifier}) => {
    commit(CART_SET_CHECKOUT_STATUS, null);
    if(identifier === parseInt(identifier, 10)) {
      commit(CART_REMOVE_ITEM_BY_INDEX, identifier);
    } else {
      commit(CART_REMOVE_ITEM_BY_UUID, identifier);
    }
    commit(CART_SAVE);
  },

  CART_CLEAR_ITEMS: ({commit}) => {
    commit(CART_SET_CHECKOUT_STATUS, null);
    commit(CART_CLEAR);
    commit(CART_SAVE);
  },

};

export default {
  getters,
  mutations,
  actions,
  state
}
